import {DashboardDao} from '../../../dao';
import {ErrorModel} from '../../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'GET_ALL_ADMIN_DASHBOARD_GROSS_MARGIN';

export async function getGrossMargin(userData: Record<string, string>, params: string) {
    try {
        const result = await DashboardDao.AdminDao.getGrossMargin(userData.userToken, params);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
